import React from 'react';

import Button from '../../../../../../components/Button';
import Input from '../../../../../../components/Input';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useAdminRound } from '../../../../../../contrib/Hooks/useAdminRound.hook';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';
import { search } from '../../Utils/search';

export const GroupActions = () => {
  const { roundId } = useRouteInfoState();

  const { searchValue } = useTeeSheetCreatorState();

  const { dispatch } = useTeeSheetCreatorDispatch();

  const [round] = useAdminRound(roundId);

  const collapseAll = () =>
    dispatch({ type: 'set', value: { attribute: 'openGroups', value: {} } });

  const onClear = async () => {
    dispatch({ type: 'set', value: { attribute: 'dialogActions', value: { clear: true } } });
    dispatch({
      type: 'set',
      value: { attribute: 'dialogTitle', value: 'Clear the Group assignation' }
    });
    dispatch({
      type: 'set',
      value: { attribute: 'dialogText', value: `Are you sure you CLEAR the round groups?` }
    });
    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: true } });
  };

  const onAutoFill = async () => {
    dispatch({ type: 'set', value: { attribute: 'dialogActions', value: { autoFill: true } } });
    dispatch({
      type: 'set',
      value: { attribute: 'dialogTitle', value: 'Autofill group assignation' }
    });

    dispatch({
      type: 'set',
      value: {
        attribute: 'dialogText',
        value: `This action will fill the group assignation automatically...`
      }
    });

    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: true } });
  };

  return (
    <div className="group-actions">
      <div className="buttons">
        {false && (
          <Button color="primary" className="button" onClick={onAutoFill}>
            Fill Shortcut
          </Button>
        )}
        <Button color="primary" className="button" onClick={onClear}>
          clear Sheet
        </Button>
        <Button color="primary" className="button" onClick={collapseAll}>
          Collapse All
        </Button>
      </div>

      <Input
        id="player-lookup"
        label="PLAYER LOOKUP"
        onChange={search(dispatch, round || null)}
        outlined={true}
        placeholder="PLAYER LOOKUP"
        type="search"
        value={searchValue}
      />
    </div>
  );
};
